module.exports = __webpack_public_path__ + "public/images/Illustration_Reading_200x174.ecdd94ade14c1608f0004ae52f0d1722.png";